import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "step1", "step2", "notesWrapper", "notesField", "reasonInput", "resolutionField"]

  onReasonChange(event) {
    const reason = event.target.value
    const placeholder = event.target.dataset.notesPlaceholder

    if (reason === "disagree_with_findings") {
      this.#showStep2()
    } else {
      this.#showStep1(placeholder)
    }
  }

  submit() {
    if (!this.#selectedReason()) return
    this.formTarget.requestSubmit()
  }

  cancel() {
    const details = this.element.closest("details")
    if (details) details.removeAttribute("open")
  }

  confirmDisagreement() {
    if (this.hasResolutionFieldTarget) this.resolutionFieldTarget.disabled = false
    this.formTarget.requestSubmit()
  }

  backToStep1() {
    this.reasonInputTargets.forEach((input) => { input.checked = false })
    if (this.hasNotesFieldTarget) this.notesFieldTarget.value = ""
    this.#showStep1(null)
  }

  #showStep1(placeholder) {
    this.step1Target.classList.remove("hidden")
    this.step2Target.classList.add("hidden")
    if (placeholder) {
      this.notesFieldTarget.placeholder = placeholder
      this.notesWrapperTarget.classList.remove("hidden")
    } else {
      this.notesWrapperTarget.classList.add("hidden")
    }
  }

  #showStep2() {
    this.step1Target.classList.add("hidden")
    this.step2Target.classList.remove("hidden")
  }

  #selectedReason() {
    return this.reasonInputTargets.find((input) => input.checked) || null
  }
}
